import React from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { PlatformsList } from './components/PlatformsList'

const PlatformsPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Platforms</PageTitle>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-lg-row-fluid'>
          <PlatformsList />
        </div>
      </div>
    </>
  )
}

export { PlatformsPage }

